<template>
  <el-dialog
    title="材料详情"
    :visible.sync="visible"
    width="900px"
    @close="$emit('update:show', false)"
  >
    <el-tabs type="border-card">
      <el-tab-pane label="入库记录">
        <el-table :data="item_in_records.list">
          <el-table-column label="入库类型" align="center">
            <template slot-scope="scope">{{
              ItemStockInCategoryMap[scope.row.stock_in_category]
            }}</template>
          </el-table-column>
          <!-- <el-table-column
            label="供应方"
            align="center"
            prop="supplier"
          ></el-table-column>
          <el-table-column
            label="到货日期"
            align="center"
            prop="arrive_date"
          ></el-table-column>
          <el-table-column
            label="到货批次"
            align="center"
            prop="arrive_batch"
          ></el-table-column> -->
          <!-- <el-table-column
            label="税率"
            align="center"
            prop="tax_rate"
          ></el-table-column>
          <el-table-column
            label="含税价格"
            align="center"
            prop="price"
          ></el-table-column> -->
          <el-table-column
            label="数量"
            align="center"
            prop="number"
          ></el-table-column>
          <!-- <el-table-column
            label="剩余"
            align="center"
            prop="left_number"
          ></el-table-column> -->
          <el-table-column label="入库时间" align="center">
            <template slot-scope="scope">
              {{ $time(scope.row.confirm_time).format('YYYY-MM-DD') }}
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :records="item_in_records.count"
          :page="pageIn"
          :per-page="20"
          @paginate="loadRecordInData"
        ></pagination>
      </el-tab-pane>
      <el-tab-pane label="出库记录">
        <el-table :data="item_out_records.list">
          <!-- <el-table-column
            label="供应方"
            align="center"
            prop="item_in_record.supplier"
          ></el-table-column>
          <el-table-column
            label="到货日期"
            align="center"
            prop="item_in_record.arrive_date"
          ></el-table-column>
          <el-table-column
            label="出货批次"
            align="center"
            prop="item_in_record.arrive_batch"
          ></el-table-column> -->
          <el-table-column label="出库类型" align="center">
            <template slot-scope="scope">{{
              ItemStockOutCategoryMap[scope.row.stock_out_category]
            }}</template>
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            prop="number"
          ></el-table-column>
          <el-table-column label="出库时间" align="center">
            <template slot-scope="scope">
              {{ $time(scope.row.created_at).format('YYYY-MM-DD') }}
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :records="item_out_records.count"
          :page="pageOut"
          :per-page="20"
          @paginate="loadRecordOutData"
        ></pagination>
      </el-tab-pane>
      <el-tab-pane label="盘点记录">
        <el-table :data="item_inventories.list">
          <el-table-column label="盘点类型" align="center">
            <template slot-scope="scope">
              {{ scope.row.category == 1 ? '月度盘点' : '年度盘点' }}
            </template>
          </el-table-column>
          <el-table-column
            label="盘点人"
            align="center"
            prop="user_name"
          ></el-table-column>
          <el-table-column label="盘点时间" align="center">
            <template slot-scope="scope">
              {{ $time(scope.row.updated_at).format('YYYY-MM-DD') }}
            </template>
          </el-table-column>
          <el-table-column label="盘点状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.current_stock_number }}
              <span
                :class="
                  scope.row.inventory_result < 0
                    ? 'text-danger'
                    : 'text-success'
                "
              >
                （{{ scope.row.inventory_result < 0 ? '' : '+'
                }}{{ scope.row.inventory_result }}）
              </span>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="left" prop="remark">
          </el-table-column>
        </el-table>
        <pagination
          :records="item_inventories.count"
          :page="pageInventory"
          :per-page="20"
          @paginate="loadInventoryData"
        ></pagination>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import {
  itemDetail,
  itemInRecordList,
  itemOutRecordList,
  itemInventoryRecord,
} from '@/service/getData'
import {
  ItemStockInCategoryMap,
  ItemStockOutCategoryMap,
} from '@/config/global'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (this.visible) {
        if (this.model.id) {
          this.getItemInRecords()
          this.getItemOutRecords()
          this.getItemInventories()
        }
      }
    },
  },
  data() {
    return {
      ItemStockInCategoryMap,
      ItemStockOutCategoryMap,
      item: {},
      loading: false,
      visible: this.show,
      pageIn: 1,
      pageOut: 1,
      pageInventory: 1,
      item_in_records: {
        list: [],
        count: 0,
      },
      item_out_records: {
        list: [],
        count: 0,
      },
      item_inventories: {
        list: [],
        count: 0,
      },
    }
  },
  methods: {
    async loadRecordInData(page) {
      this.pageIn = page
      this.getItemInRecords()
    },
    async loadRecordOutData(page) {
      this.pageOut = page
      this.getItemOutRecords()
    },
    async loadInventoryData(page) {
      this.pageInventory = page
      this.getItemInventories()
    },
    async getItemInventories() {
      let res = await itemInventoryRecord({
        page: this.pageInventory - 1,
        item_id: this.model.id,
        status: 1,
      })
      if (res.status == 0) {
        this.item_inventories = res.data
      }
    },
    async getItemInRecords() {
      let res = await itemInRecordList({
        page: this.pageIn - 1,
        item_id: this.model.id,
        status: 0,
      })
      if (res.status == 0) {
        this.item_in_records = res.data
      }
    },
    async getItemOutRecords() {
      let res = await itemOutRecordList({
        page: this.pageOut - 1,
        item_id: this.model.id,
      })
      if (res.status == 0) {
        this.item_out_records = res.data
      }
    },
  },
}
</script>